// sol/SolWrapper.js
import React, { useMemo } from "react";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { 
  PhantomWalletAdapter, 
  SolflareWalletAdapter, 
  TorusWalletAdapter,
  Coin98WalletAdapter,
  HuobiWalletAdapter,
  TrustWalletAdapter,
  BackpackWalletAdapter,
  AlphaWalletAdapter,
  AvanaWalletAdapter,
  BloctoWalletAdapter,
  BraveWalletAdapter,
  CensoWalletAdapter,
  CloverWalletAdapter,
  CoinhubWalletAdapter,
  FractalWalletAdapter,
  GlowWalletAdapter,
  LedgerWalletAdapter,
  MathWalletAdapter,
  SlopeWalletAdapter,
  SolongWalletAdapter,
  SolletExtensionWalletAdapter,
  SolletWalletAdapter,
  KrystalWalletAdapter,
  SafePalWalletAdapter,
  ExodusWalletAdapter,
  CoinbaseWalletAdapter,
  BitKeepWalletAdapter,
  BitpieWalletAdapter,
  HyperPayWalletAdapter,
  SkyWalletAdapter,
  SpotWalletAdapter,
  BitgetWalletAdapter,
  WalletConnectWalletAdapter
} from "@solana/wallet-adapter-wallets";
import { clusterApiUrl } from "@solana/web3.js";

import "@solana/wallet-adapter-react-ui/styles.css";

export default function SolWrapper({ children }) {
  const network = WalletAdapterNetwork.Mainnet;
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  const wallets = useMemo(() => [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
    new TrustWalletAdapter(),
    new CoinbaseWalletAdapter(),
    new TorusWalletAdapter(),
    new Coin98WalletAdapter(),
    new BitgetWalletAdapter(),
    new ExodusWalletAdapter(),
    new HuobiWalletAdapter(),
    new BitKeepWalletAdapter(),
    new BitpieWalletAdapter(),
    new BackpackWalletAdapter(),
    new AlphaWalletAdapter(),
    new AvanaWalletAdapter(),
    new BloctoWalletAdapter(),
    new BraveWalletAdapter(),
    new CensoWalletAdapter(),
    new CloverWalletAdapter(),
    new CoinhubWalletAdapter(),
    new FractalWalletAdapter(),
    new GlowWalletAdapter(),
    new LedgerWalletAdapter(),
    new MathWalletAdapter(),
    new SlopeWalletAdapter(),
    new SolongWalletAdapter(),
    new SolletExtensionWalletAdapter(),
    new SolletWalletAdapter(),
    new KrystalWalletAdapter(),
    new HyperPayWalletAdapter(),
    new SafePalWalletAdapter(),
    new SkyWalletAdapter(),
    new SpotWalletAdapter(),
    new WalletConnectWalletAdapter()
  ], [network]);

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          {children}
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}
